import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

type HandleProps = Record<string, unknown>;

export const SortableRow: React.VFC<{
  id: string;
  domId?: string;
  className?: string;
  extraStyle?: React.CSSProperties;
  children: (handleProps: HandleProps) => React.ReactNode;
}> = ({ id, domId, className, extraStyle, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    ...extraStyle,
  };
  return (
    <div id={domId} ref={setNodeRef} style={style} className={className}>
      {children({ ...attributes, ...listeners })}
    </div>
  );
};
